import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { useAddProjectMutation } from "../../features/projects/projectsApi";
import { controlProjectModal } from "../../features/projects/projectSlice";

export default function ProjectModal({ open, teams }) {
  //Dispather
  const dispatch = useDispatch();
  //initial Variables
  const { user: loggedInUser } = useSelector((state) => state.auth) || {};
  const { email: myEmail } = loggedInUser || {};

  //Variables
  const [description, setDescription] = useState("");
  const [selectedTeam, setSelectedTeam] = useState([]);

  //Queries
  const [addProject] = useAddProjectMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addProject({
      data: {
        creator: myEmail,
        description,
        status: "Backlog",
        teamName: selectedTeam?.value?.team?.name,
        teamColor: selectedTeam?.value?.team?.color,
        teamMembers: selectedTeam?.value?.team?.members,
        date: new Date().getTime(),
      },
    });
    dispatch(controlProjectModal());
  };

  const options = teams?.map((team) => {
    return {
      value: { team: team },
      label: team?.name,
    };
  });

  return (
    open && (
      <>
        <div
          onClick={() => dispatch(controlProjectModal())}
          className="fixed w-full h-full inset-0 z-10 bg-black/50 cursor-pointer"
        ></div>
        <div className="rounded w-[400px] lg:w-[600px] space-y-8 bg-white p-10 absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Add Team
          </h2>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div className="rounded-md shadow-sm -space-y-px">
              <Select
                required
                name="members"
                options={options}
                noOptionsMessage={() => "No Members Available"}
                onChange={setSelectedTeam}
                placeholder="Select a team"
              />
              <div>
                <textarea
                  name="description"
                  type="text"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Project description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
                disabled={selectedTeam?.length === 0}
              >
                Add Project
              </button>
            </div>

            {/* {participant?.length === 0 && (
              <Error message="This user does not exist!" />
            )}
            {participant?.length > 0 && participant[0].email === myEmail && (
              <Error message="You can not send message to yourself!" />
            )} */}

            {/* <Error message="Error" /> */}
          </form>
        </div>
      </>
    )
  );
}
